import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Badge as MuiBadge,
  type BadgeProps as MuiBadgeProps,
} from '@mui/material'
import type { DataTestIdAttribute, MinimalSxProp } from '../../types'

export type BadgeProps = Pick<MuiBadgeProps, 'children' | 'anchorOrigin' | 'invisible'> & {
  /**
   * The content rendered within the badge, when more then 100 we show 99+
   */
  badgeContent?: MuiBadgeProps['badgeContent']

  /**
   * Choose the color you need, by default its grey
   *
   * @default 'default'
   */
  color?: MuiBadgeProps['color']

  /**
   * Wrapped shape the badge should overlap.
   */
  overlap?: 'circular'

  /**
   * Variant can be dot or standard the bigger one for content
   *
   * @default 'standard'
   */
  variant?: MuiBadgeProps['variant']
} & DataTestIdAttribute &
  MinimalSxProp

/**
 * Badge
 *
 * Demos:
 * - [Badge](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-badge--docs)
 *
 */

export const Badge = ({ children, color = 'default', ...props }: BadgeProps) => (
  <MuiBadge color={color} {...props}>
    {children}
  </MuiBadge>
)
